module.exports = __webpack_public_path__ + "media/img/vca/winner2-ba1526a4eb8905aca7a9397154a40320.png";